/**
 * Available drive units to use when registering driving mileage.
 */
export type WorkAppDriveUnit = 'Trip' | 'KM' | 'OffRoad' | 'KMSpecial';
